import CellFinder from 'pages/CellFinder'
import { createElement as $, FC } from 'react'
import { Routes, Route } from 'react-router-dom'

const RoutedApp: FC = () => 
  $(Routes, null,
    $(Route, { path: '/cell-finder/*', element: $(CellFinder)}))

export default RoutedApp